import { FC } from 'react';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import { FileVariantsEnum, UserDto } from '@sweatpals/shared';
import { CheckIcon, LogoutIcon, MobileIcon, PresentationIcon, RepeatIcon, UsersIcon } from '../../../icons';
import { UserAvatar } from '../../user-avatar';
import { Colors } from '../../../constants';
import {
	currentUserLabelStyles,
	currentUserNameStyles,
	currentUserStyles,
	menuItemStyles,
	newFeatureLabelStyles,
	paperStyles,
} from './user-profile-menu.styles';

export interface UserProfileMenuProps {
	open: boolean;
	anchorEl: HTMLElement | null;
	currentUser?: UserDto | null;

	onClose(): void;
	getPublicFileUrl(fileId: string, variant?: FileVariantsEnum): string;
	openDashboardPage?(): void;
	openCreateCommunityPage?(): void;
	openDownloadAppPage?(): void;
	handleLogout?(): void;
	openBookDemoPage?(): void;
}

export const UserProfileMenu: FC<UserProfileMenuProps> = (props) => {
	const {
		open,
		anchorEl,
		currentUser,
		onClose,
		getPublicFileUrl,
		openCreateCommunityPage,
		openDownloadAppPage,
		openDashboardPage,
		handleLogout,
		openBookDemoPage,
	} = props;

	return (
		<Menu
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			slotProps={{
				paper: {
					sx: paperStyles,
				},
			}}
		>
			{currentUser && (
				<Box sx={currentUserStyles}>
					<UserAvatar
						fullName={currentUser.fullName}
						avatarSrc={currentUser.avatarId && getPublicFileUrl(currentUser.avatarId, FileVariantsEnum.XS)}
						emptyAvatarVariant={currentUser.emptyAvatarVariant}
						sx={{ width: '32px', height: '32px' }}
					/>
					<Box flex={1} display="flex" flexDirection="column" rowGap="2px">
						<Typography sx={currentUserLabelStyles}>
							Current
						</Typography>
						<Typography sx={currentUserNameStyles} fontSize="13px" fontWeight={600} lineHeight="21px">
							{currentUser?.fullName ?? currentUser?.userName}
						</Typography>
					</Box>
					<CheckIcon width="16px" height="16px" color={Colors.white} />
				</Box>
			)}
			<MenuItem sx={menuItemStyles} onClick={openDashboardPage}>
				<RepeatIcon />
				Switch to hosting
			</MenuItem>
			<MenuItem sx={menuItemStyles} onClick={openCreateCommunityPage}>
				<UsersIcon />
				Create Community
			</MenuItem>
			<MenuItem sx={menuItemStyles} onClick={openBookDemoPage}>
				<PresentationIcon />
				Book a demo
				<Box component="label" sx={newFeatureLabelStyles}>
					New
				</Box>
			</MenuItem>
			<MenuItem sx={menuItemStyles} onClick={openDownloadAppPage}>
				<MobileIcon />
				Get the App
			</MenuItem>
			<MenuItem sx={menuItemStyles} onClick={handleLogout}>
				<LogoutIcon />
				Log Out
			</MenuItem>
		</Menu>
	);
};
